import { useCallback } from 'react';
import Helmet from 'react-helmet';

import { DefaultSheet } from 'twyne-new.ui';

import { useAppAlert } from '@Components/AppAlert';
import RouterProvider, { useParams } from '@Components/RouterProvider';
import history from 'utils/history';

import { useRewardStore } from '../../../store';
import Form from '../components/Form';
import { RewardStepsProvider, useRewardStepsStore } from '../store';

function StepForm() {
  const { collection: { item, useLoad, useSubmit } } = useRewardStepsStore()
  const { handleSuccess, handleError } = useAppAlert()
  const { stepId: id } = useParams()
  const { collection: { item: reward, useLoad: useLoadReward }, reloadReward } = useRewardStore()

  const rewardId = reward?.id

  const reloadStep = useLoad(id)
  useLoadReward(rewardId)

  const handleSubmit = useSubmit()

  const handleCloseSidebar = useCallback(id => {
    history.push(`/cms/rewards/${rewardId}${id ? `/steps/${id}` : ''}`)
  }, [rewardId])

  const handleCloseAndReload = useCallback(async id => {
    await reloadReward(rewardId)
    await reloadStep(id)
    handleCloseSidebar(id)
  }, [handleCloseSidebar, reloadReward, rewardId, reloadStep])

  const handleSubmitAndClose = useCallback(async payload => {
    try {
      const data = await handleSubmit(payload)
      const message = payload.id ? 'edited' : 'created'
      handleSuccess('Success', `Step was ${message}.`)
      handleCloseAndReload(data.id)
    } catch {
      handleError('Error', 'Step was not saved.')
    }
  }, [handleCloseAndReload, handleSubmit, handleSuccess, handleError])

  if (!item) {
    return null
  }
  const order = item.id ? item.order : reward?.rewardSteps?.length
  return <>
    <DefaultSheet
      wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleCloseSidebar() }}
      title={item.id ? 'Edit Step' : 'Add Step'}
    >
      <Helmet title='Step' />
      <Form data={{ ...item, order, rewardId, rewardSteps: reward?.rewardSteps }} handleSubmit={handleSubmitAndClose} onCancel={handleCloseSidebar} />
    </DefaultSheet>
  </>
}

export default function StepFormLayout() {
  return <RewardStepsProvider>
    <RouterProvider>
      <StepForm />
    </RouterProvider>
  </RewardStepsProvider>
}
